export const preventDefaultOnEnterKeyPress = (
  e: React.KeyboardEvent<HTMLElement>
) => {
  e.key === 'Enter' && e.preventDefault();
};
